<template>
  <div style="clear: both; text-align: left;">


    <edit-pane ref="step2"
     :save-disabled="prgRefreshing"
    @save="onSave" @cancel="onCancel" @edit="onEdit" />


    <el-form ref='prgStep2' label-position="top" v-model='intApp'>

     <el-row :gutter="8">

      <el-col :span="12">
         <el-form-item>
         <select-action-status  v-model="step.status" :disabled="dis" />
        </el-form-item>
      </el-col>

       <el-col :span="12">
       <el-form-item>
         <select-priority  v-model="step.priority" :disabled="dis"/>
         </el-form-item>
        </el-col>


        <el-col v-if="intApp" :span="4">
          <el-form-item label="Permit Type" required>
            <el-input v-model="intApp.permitType" placeholder="Permit Type" :disabled="dis"></el-input>
          </el-form-item>
        </el-col>

        <el-col v-if="intApp" :span="4"  :offset="1">
          <el-form-item label="Land Status" required>
            <el-input v-model="intApp.landStatus" placeholder="Land Status" :disabled="dis"></el-input>
          </el-form-item>
        </el-col>

        <el-col v-if="intApp" :span="6"  :offset="1">
          <select-authority v-model="intApp.authority" :disabled="dis" />
        </el-col>

        <el-col v-if="intApp" :span="8">
          <el-form-item>
              <select-users v-model="intApp.updated_by" :disabled="dis" />
          </el-form-item>
        </el-col>

    </el-row>


    <el-row>
      <h3>Fee Types</h3>
    </el-row>

    <div v-if="intApp">
      <div v-for="(fee, index) in intApp.fees" :key="fee.name">
        <el-row>
          <h4>{{fee.name}}</h4>
        </el-row>

        <el-row :gutter="16">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item  :label-width="labelWidth">
              <text-input
              :id="'amnt' + index"
              type="number"
              v-model="fee.amount"
              :placeholder="fee.name + ' Amount'"
              :disabled="dis" />
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item :label-width="labelWidth">
              <el-input v-model="fee.chqNo"
              :id="'chq' + index"
              :placeholder="fee.name + ' Cheque #'"
              :disabled="dis" />
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item :label-width="labelWidth">
              <el-date-picker value-format="yyyy-MM-dd" :format="dateFormat"
              :id="'chqreq' + index"
              v-model="fee.chqDate"
              :placeholder="fee.name + ' Cheque Received'"
              :disabled="dis" />
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item :label-width="labelWidth">
              <el-date-picker value-format="yyyy-MM-dd" :format="dateFormat"
              :id="'chqsub' + index"
              v-model="fee.submittedOn"
              :placeholder="fee.name + ' Submitted'"
              :disabled="dis" />
            </el-form-item>
          </el-col>

        </el-row>
      </div>
    </div>

    <el-row>
      <h3>Approvals</h3>
    </el-row>

    <el-row v-if="intApp" align="middle" :gutter="16">

      <el-col :sm="24" :md="8" :lg="6"
      v-for="(ref, index) in intApp.refs" :key="ref.name">

        <el-form-item :label="ref.name + ' Ref.'">
          <el-input v-model="ref.ref"
          :id="'appref' + index"
          :placeholder="ref.name + ' Ref.'"
          :disabled="dis" />
        </el-form-item>

        <el-form-item :label="ref.name + ' Submitted'">
          <el-date-picker value-format="yyyy-MM-dd" :format="dateFormat"
          :id="'appsub' + index"
          v-model="ref.submittedOn"
          placeholder="Submitted"
          :disabled="dis" />
        </el-form-item>

        <el-form-item :label="ref.name + ' Status'">
          <el-select :format="dateFormat"
          :id="'appstat' + index"
          v-model="ref.status"
          placeholder="Status"
          :disabled="dis">
          <el-option
          v-for="st in status"
          :label="st.type" :value="st.type" :key="st.type" />
        </el-select>
      </el-form-item>

      <el-form-item :label="ref.name + ' Decision'">
        <el-date-picker value-format="yyyy-MM-dd" :format="dateFormat"
        :id="'appsd' + index"
        v-model="ref.statusDate"
        placeholder="Status Date"
        :disabled="dis" />
      </el-form-item>

      <html-input
        :label="ref.name + ' Remarks'"
        :id="'rem' + index"
        v-model="ref.remarks"
        placeholder="Remarks"
        :disabled="dis" />

      </el-col>

    </el-row>

  </el-form>

  <files-panel
    v-if="rowData.id"
    type="site"
    :id="rowData.site_id"
    process="progress"
    :process-id="rowData.id"
    :disabled="dis"
    :max-files="20"
     />

 </edit-pane>

</div>
</template>


<script>

import {settings} from '@/components/Data'

import ProgressStepMixins from '@/mixins/ProgressStepMixins'

import SelectAuthority from '@/components/atoms/selects/SelectAuthority'

export default {
  // XOL-596: Edit / Save / Cancel (versioned saves, PRG approval command) live in
  // the mixin; this component only declares its form.
  mixins: [ProgressStepMixins],

  components: {
    SelectAuthority,
  },

  props: {
    siteId: {
      type: Number,
      required: true
    },

    rowData: {
      type: Object,
      required: true
    },

    stepData: {
      type: Object,
      required: true
    },

    disabled: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    stepData: function (data) {
      this.stepData = data
    }
  },

  methods: {
    completedDate (date, toggle) {
      if (!date) {
        toggle = true
      } else {
        toggle = false
      }
    },

    completedToggle (date, toggle) {
      if (!toggle) {
        date = new Date()
      } else {
        date = null
      }
//      console.log('completedToggle', date, toggle)
    },

  },

  data () {
    return {
      // XOL-596 (ProgressStepMixins)
      prgPane: 'step2',
      prgHasApproval: false,
      step: this.stepData,
      dis: this.disabled,
      actionData: this.rowData,
      intApp: this.stepData.state,
      dateFormat: settings.selectDateFormat,
      labelWidth: '10px',
      status: [
        {type: 'Pending'},
        {type: 'Rejected'},
        {type: 'Approved'}
      ],

    } // return
  } // data

}

</script>
